module.exports = __webpack_public_path__ + "2aff2f19767c0f8eddab61bb9bc28c7b.svg";